import { Stack, Typography, Card, useTheme } from "@mui/material";

import { RHFCheckbox } from "@app/components";
import { Strings, imageSource } from "@app/constants";

const ConfirmationsCards = () => {
  const theme = useTheme();

  return (
    <Card variant="outlined" sx={{ p: 3, width: "100%" }}>
      <Typography fontWeight={700} color={theme.palette.grey[900]} gutterBottom>
        {Strings.buy.confirmation}
      </Typography>
      <Typography
        fontWeight={500}
        sx={{ color: theme.palette.grey[600], fontSize: 15 }}
      >
        {Strings.buy.weAreGettingTo}
      </Typography>

      <RHFCheckbox name="sendEmails" label={Strings.buy.iAgreeWith} />
      <RHFCheckbox name="termAndCondition" label={Strings.buy.iAgreeWithOur} />

      <Stack direction="row" alignItems="center" gap={1} mt={2}>
        <img
          src={imageSource.icSecuritySafety}
          alt="security"
          height={20}
          loading="lazy"
        />
        <Typography fontWeight={600} color={theme.palette.grey[900]}>
          {Strings.buy.allYourData}
        </Typography>
      </Stack>
      <Typography
        fontWeight={500}
        sx={{ color: theme.palette.grey[600], fontSize: 15 }}
      >
        {Strings.buy.weAreUsingThe}
      </Typography>
    </Card>
  );
};

export { ConfirmationsCards };
